// extracted by mini-css-extract-plugin
export default {"root":"PaletteFormNav_root__Z9hm1","navBtns":"PaletteFormNav_navBtns__XAtHj","appBar":"PaletteFormNav_appBar__Xr0Hv"};